// @ts-nocheck


import { createSlice } from '@reduxjs/toolkit';



import { defaultPageSize } from './constants';

import { fuelAndOilApi } from '../lib/api';


export const FETCH_FUELS_AND_OILS = 'vehicles/fuels-and-oils/fetch';
export const DELETE_VEHICLE_MODEL = 'vehicles/models/delete';



const initialState = {
  data: [],
  page: 1,
  pageSize: defaultPageSize,
  totalCount: 0
};

const fuelsAndOilsSlice = createSlice({
  name: 'vehicles/fuels-and-oils',
  initialState,
  reducers: {
    fetch: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const fuelsAndOilsActions = fuelsAndOilsSlice.actions;

export const fetchFuelsAndOils = (
page = 1,
params = {}) =>
async (dispatch, getState) => {
  const { pageSize } = getState().fuelsAndOils;
  const { data, totalCount } = await fuelAndOilApi.fetchFuelsAndOils({
    page,
    pageSize,
    ...params
  });
  dispatch(
    fuelsAndOilsActions.fetch({
      data,
      totalCount,
      page,
      pageSize
    })
  );
};

export default fuelsAndOilsSlice.reducer;
